import axios, { AxiosError } from 'axios';
import { ApiLogin } from '../axios-config';
import { conexao } from '../../../offline/conexao';
import { autenticarOffline, lembrarCredenciais } from '../../../offline/loginOffline';

interface IAuth {
   accessToken: string;
}
export interface IUsuarios {
    login: string;
    senha: string;
}
interface ErrorResponse {
  errors: {
    default: string;
  };
}
const authOnline = async (login: string, senha: string): Promise<IAuth | Error> => {
  try {
    const dados = {
      login: login,
      senha : senha,
    };
    const { data } = await ApiLogin.post('/login', dados);
    if (data) {
      return data;
    }
    return new Error('Erro no login.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
// Sem conexão com o servidor de login, confere usuário e senha contra a
// cópia local dos usuários da empresa (ver shared/offline/loginOffline).
const auth = async (login: string, senha: string): Promise<IAuth | Error> => {
  const resultado = conexao.estaOffline() ? new Error('offline') : await authOnline(login, senha);
  if (!(resultado instanceof Error)) {
    lembrarCredenciais(login, senha);
    return resultado;
  }
  if (!conexao.estaOffline()) return resultado;
  const tokenLocal = await autenticarOffline(login, senha);
  return tokenLocal instanceof Error ? tokenLocal : { accessToken: tokenLocal };
};

export const AuthService = {
  auth,
}; 